export const CLIENT_GROUP_MAP = {
    "REPORT": ["BSEP", "PGEU-001", "PGTN-001", "BLLI","ASPR","STI3"],
    "UR": ["URCO", "URCL", "URVE"]
};

export const getClientsForGroup = (code) => {
    if (!code) return [];
    if (CLIENT_GROUP_MAP[code]) return CLIENT_GROUP_MAP[code];
    return [code];
};